<template>
    <div>
        <div class="active_top_title">全网所有产品，订购享好礼 <span @click="xin.goUrl('/product')" class="go_active">戳 ></span></div>
        <div v-loading="loading" class="msg_box min_he400">
            <p class="active_center">更多产品资料、活动信息可<span @click="isEwm=true" class="laing2">关注公众号【同仁化学DOJINDO】</span></p>
            <!-- <div class="active_imgs">
				<div class="active_image" v-for="(item) in actvity.banner" :key="item.id">
					<div class="active_title">{{item.title}}</div>
					<img @click="xin.goNew(item.url)" :src="item.images"/>
				</div>
			</div> -->
            <div class="tech_title">限时活动</div>
            <div class="active_list">
                <div class="active_zi" v-for="(item) in actvity.list" :key="item.id">
                    <span class="li_chin">
                        <img @click="xin.goUrl('/activityDetails?aid='+item.id)" :src="item.images" />
                    </span>
                    <div class="active_content">
                        <div @click="xin.goUrl('/activityDetails?aid='+item.id)" class="font20">{{item.title}}</div>
                        <div>{{item.subtitle}}</div>
                        <div @click="xin.goUrl('/activityDetails?aid='+item.id)" class="gos">了解更多></div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog class="erweima" title="扫码关注公众号" center :visible.sync="isEwm" width="400px">
            <img src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/qrcode_for_gh_1bf2f15c3a63_430.jpg" />
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            isEwm: false,
            actvity: {},
            activeList: []
        }
    },
    created() {
        this.Postactivitylists();
    },
    methods: {
        async Postactivitylists() {
            this.loading = true;
            let { data } = await this.api.Postactivitylists();
            this.actvity = data;
            this.loading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.active_list {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .active_zi {
        margin-top: 20px;
        .active_content {
            margin-left: 10px;
            float: right;
            width: 270px;

            color: #8f8f8f;
            .font20 {
                cursor: pointer;
                padding: 10px 0;
            }
            .gos {
                color: #b03130;
                cursor: pointer;
            }
        }
        .li_chin {
            float: left;
        }
        img {
            width: 300px;
            height: 225px;
            border: 1px dashed #dbd3d3;
        }
    }
}

// 活动广告
.active_imgs {
    display: flex;
    justify-content: space-between;
    .active_image {
        margin: 0 10px;
        .active_title {
            margin: 10px 0;
            font-size: 24px;
            text-align: center;
        }
        img {
            width: 100%;
            cursor: pointer;
        }
    }
}
.active_center {
    text-align: center;
}
.active_top_title {
    font-size: 20px;
    background: rgba(176, 49, 48, 0.5);
    color: #fff;
    width: 100%;
    height: 60px;
    display: flex;
    min-width: 1200px;
    justify-content: center;
    line-height: 60px;
    .go_active {
        font-size: 16px;
        margin-left: 30px;
        cursor: pointer;
    }
}
</style>
